import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import useGetMediaLocation from "../hooks/useGetMediaLocation";

import { cuesApi } from "../../imports";

export default function Video({ cue, forceMute = false }) {
	const { projectId } = useParams();
	const videoRef = useRef();
	const mediaLocation = useGetMediaLocation();

	// const audioSource = useMemo(() => {
	// 	// This ensures the audio can load when switching between sources on the same cue
	// 	videoRef?.current?.load();
	// 	return <source src={`${mediaLocation}${cue.filename}`} type="audio/mp3" />;
	// }, [cue.filename, mediaLocation]);

	const fadeOutAudio = () => {
		if (!videoRef.current) return;

		const audio = videoRef.current;
		const fadeDuration = 1000; // Fade duration in milliseconds
		const fadeStep = 0.01; // Decrease the volume by this amount on each step
		const fadeInterval = fadeDuration * fadeStep; // Calculate the time between each step

		const fade = () => {
			if (!audio) return;

			// Lower the volume
			audio.volume = Math.max(audio.volume - fadeStep, 0);

			// If the volume is still greater than 0, continue fading
			if (audio.volume > 0) {
				setTimeout(fade, fadeInterval);
			} else {
				audio.pause();
			}
		};

		fade();
	};

	useEffect(() => {
		if (cue.status === "coming") {
			const audio = videoRef.current;
			audio.volume = (cue.volume || 100) / 100;
			videoRef?.current?.play();
		}
		if (cue.status === "going") fadeOutAudio();
	}, [cue.status, cue.volume]);

	useEffect(() => {
		const audio = videoRef.current;
		audio.volume = (cue?.volume || 100) / 100;
	}, [cue.volume]);

	return (
		<>
			<video
				className={`h-screen w-screen
                object-${cue.backgroundFit || "cover"} 
                `}
				ref={videoRef}
				type="video/webm"
				src={`${mediaLocation}${cue.filename}`}
				onCanPlay={(e) => {
					if (!["onair", "coming"].includes(cue.status)) {
						// console.log("PAUSED");
						e.target.pause();
					}
					cuesApi.updateCue(cue.id, projectId, {
						length: e.target.duration,
					});
				}}
				onTimeUpdate={(e) => {
					if (cue.loop && e.target.currentTime >= cue.length - 0.1) {
						cuesApi.updateCue(cue.id, projectId, {
							currentTime: 0,
						});
						e.target.currentTime = 0;
					}
					if (e.target.currentTime > cue.currentTime + 0.5) {
						cuesApi.updateCue(cue.id, projectId, {
							currentTime: e.target.currentTime,
						});
					}
				}}
				onPlay={(e) => {
					if (e.target.currentTime > 0) {
						e.target.currentTime = 0;
					}
				}}
				onEnded={(e) => {
					switch (cue.onEnd) {
						case 'hold_last':
							cuesApi.updateCue(cue.id, projectId, {
								currentTime: e.target.duration,
							});
							break;

						case 'hold_first':
							cuesApi.updateCue(cue.id, projectId, {
								currentTime: 0,
							});
							e.target.currentTime = 0;
							break;
					
						default:
							cuesApi.updateCue(cue.id, projectId, {
								status: "going",
							});
							return setTimeout(() => {
									cuesApi.updateCue(cue.id, projectId, {
										currentTime: 0,
									});
									e.target.currentTime = 0;
								}, 1000);
					}

					
				}}
				controls={false}
				// autoPlay={true}
				muted={
					forceMute || ["offair", "ready", "cuedon"].includes(cue?.status)
						? true
						: cue.mute || false
				}
				playsInline={true}
				loop={cue.loop || false}
			></video>
		</>
	);
}
